// Currency utility functions

export const CURRENCY_INFO = {
  "USD": {"name": "US Dollar", "symbol": "$", "code": "USD"},
  "EUR": {"name": "Euro", "symbol": "€", "code": "EUR"},
  "GBP": {"name": "British Pound", "symbol": "£", "code": "GBP"},
  "CAD": {"name": "Canadian Dollar", "symbol": "C$", "code": "CAD"},
  "AUD": {"name": "Australian Dollar", "symbol": "A$", "code": "AUD"},
  "JPY": {"name": "Japanese Yen", "symbol": "¥", "code": "JPY"},
  "CNY": {"name": "Chinese Yuan", "symbol": "¥", "code": "CNY"},
  "INR": {"name": "Indian Rupee", "symbol": "₹", "code": "INR"},
  "BRL": {"name": "Brazilian Real", "symbol": "R$", "code": "BRL"},
  "MXN": {"name": "Mexican Peso", "symbol": "$", "code": "MXN"},
  "ZAR": {"name": "South African Rand", "symbol": "R", "code": "ZAR"},
  "SGD": {"name": "Singapore Dollar", "symbol": "S$", "code": "SGD"},
  "HKD": {"name": "Hong Kong Dollar", "symbol": "HK$", "code": "HKD"},
  "NZD": {"name": "New Zealand Dollar", "symbol": "NZ$", "code": "NZD"},
  "SEK": {"name": "Swedish Krona", "symbol": "kr", "code": "SEK"},
  "NOK": {"name": "Norwegian Krone", "symbol": "kr", "code": "NOK"},
  "DKK": {"name": "Danish Krone", "symbol": "kr", "code": "DKK"},
  "CHF": {"name": "Swiss Franc", "symbol": "CHF", "code": "CHF"},
  "RUB": {"name": "Russian Ruble", "symbol": "₽", "code": "RUB"},
  "KRW": {"name": "South Korean Won", "symbol": "₩", "code": "KRW"},
  "THB": {"name": "Thai Baht", "symbol": "฿", "code": "THB"},
  "MYR": {"name": "Malaysian Ringgit", "symbol": "RM", "code": "MYR"},
  "PHP": {"name": "Philippine Peso", "symbol": "₱", "code": "PHP"},
  "VND": {"name": "Vietnamese Dong", "symbol": "₫", "code": "VND"},
  "AED": {"name": "UAE Dirham", "symbol": "AED", "code": "AED"},
  "SAR": {"name": "Saudi Riyal", "symbol": "SAR", "code": "SAR"},
  "QAR": {"name": "Qatari Riyal", "symbol": "QAR", "code": "QAR"},
  "KWD": {"name": "Kuwaiti Dinar", "symbol": "KWD", "code": "KWD"},
  "BHD": {"name": "Bahraini Dinar", "symbol": "BHD", "code": "BHD"},
  "OMR": {"name": "Omani Rial", "symbol": "OMR", "code": "OMR"},
  "JOD": {"name": "Jordanian Dinar", "symbol": "JOD", "code": "JOD"},
  "LBP": {"name": "Lebanese Pound", "symbol": "LBP", "code": "LBP"},
  "EGP": {"name": "Egyptian Pound", "symbol": "EGP", "code": "EGP"},
  "TRY": {"name": "Turkish Lira", "symbol": "₺", "code": "TRY"},
  "ILS": {"name": "Israeli Shekel", "symbol": "₪", "code": "ILS"},
  "PLN": {"name": "Polish Zloty", "symbol": "zł", "code": "PLN"},
  "CZK": {"name": "Czech Koruna", "symbol": "Kč", "code": "CZK"},
  "HUF": {"name": "Hungarian Forint", "symbol": "Ft", "code": "HUF"},
  "RON": {"name": "Romanian Leu", "symbol": "lei", "code": "RON"},
  "BGN": {"name": "Bulgarian Lev", "symbol": "лв", "code": "BGN"},
  "HRK": {"name": "Croatian Kuna", "symbol": "kn", "code": "HRK"},
  "RSD": {"name": "Serbian Dinar", "symbol": "RSD", "code": "RSD"},
  "UAH": {"name": "Ukrainian Hryvnia", "symbol": "₴", "code": "UAH"},
  "BYN": {"name": "Belarusian Ruble", "symbol": "Br", "code": "BYN"},
  "KZT": {"name": "Kazakhstani Tenge", "symbol": "₸", "code": "KZT"},
  "UZS": {"name": "Uzbekistani Som", "symbol": "soʻm", "code": "UZS"},
  "AMD": {"name": "Armenian Dram", "symbol": "֏", "code": "AMD"},
  "GEL": {"name": "Georgian Lari", "symbol": "₾", "code": "GEL"},
  "AZN": {"name": "Azerbaijani Manat", "symbol": "₼", "code": "AZN"},
  "PKR": {"name": "Pakistani Rupee", "symbol": "₨", "code": "PKR"},
  "BDT": {"name": "Bangladeshi Taka", "symbol": "৳", "code": "BDT"},
  "LKR": {"name": "Sri Lankan Rupee", "symbol": "Rs", "code": "LKR"},
  "NPR": {"name": "Nepalese Rupee", "symbol": "₨", "code": "NPR"},
  "IDR": {"name": "Indonesian Rupiah", "symbol": "Rp", "code": "IDR"},
  "TWD": {"name": "Taiwan Dollar", "symbol": "NT$", "code": "TWD"},
  "MNT": {"name": "Mongolian Tugrik", "symbol": "₮", "code": "MNT"},
  "KHR": {"name": "Cambodian Riel", "symbol": "៛", "code": "KHR"},
  "LAK": {"name": "Lao Kip", "symbol": "₭", "code": "LAK"},
  "MMK": {"name": "Myanmar Kyat", "symbol": "K", "code": "MMK"},
  "BND": {"name": "Brunei Dollar", "symbol": "B$", "code": "BND"},
  "CLP": {"name": "Chilean Peso", "symbol": "$", "code": "CLP"},
  "ARS": {"name": "Argentine Peso", "symbol": "$", "code": "ARS"},
  "COP": {"name": "Colombian Peso", "symbol": "$", "code": "COP"},
  "PEN": {"name": "Peruvian Sol", "symbol": "S/", "code": "PEN"},
  "UYU": {"name": "Uruguayan Peso", "symbol": "$U", "code": "UYU"},
  "VEF": {"name": "Venezuelan Bolívar", "symbol": "Bs", "code": "VEF"},
  "BOB": {"name": "Bolivian Boliviano", "symbol": "Bs", "code": "BOB"},
  "PYG": {"name": "Paraguayan Guaraní", "symbol": "₲", "code": "PYG"},
  "ETB": {"name": "Ethiopian Birr", "symbol": "Br", "code": "ETB"},
  "KES": {"name": "Kenyan Shilling", "symbol": "KSh", "code": "KES"},
  "TZS": {"name": "Tanzanian Shilling", "symbol": "TSh", "code": "TZS"},
  "UGX": {"name": "Ugandan Shilling", "symbol": "USh", "code": "UGX"},
  "RWF": {"name": "Rwandan Franc", "symbol": "RF", "code": "RWF"},
  "NGN": {"name": "Nigerian Naira", "symbol": "₦", "code": "NGN"},
  "GHS": {"name": "Ghanaian Cedi", "symbol": "₵", "code": "GHS"},
  "XOF": {"name": "West African CFA Franc", "symbol": "CFA", "code": "XOF"},
  "XAF": {"name": "Central African CFA Franc", "symbol": "FCFA", "code": "XAF"},
  "DZD": {"name": "Algerian Dinar", "symbol": "دج", "code": "DZD"},
  "MAD": {"name": "Moroccan Dirham", "symbol": "DH", "code": "MAD"},
  "TND": {"name": "Tunisian Dinar", "symbol": "د.ت", "code": "TND"},
  "LYD": {"name": "Libyan Dinar", "symbol": "LD", "code": "LYD"}
};

// Legacy symbol mapping for backward compatibility
export const CURRENCY_SYMBOLS = Object.fromEntries(
  Object.entries(CURRENCY_INFO).map(([code, info]) => [code, info.symbol])
);

// Format price with currency code after amount (new format)
export const formatPrice = (price, currency = 'USD') => {
  const info = CURRENCY_INFO[currency] || CURRENCY_INFO['USD'];
  const code = info.code;
  
  // Currencies that don't use decimal places
  const noDecimalCurrencies = ['JPY', 'KRW', 'VND'];
  
  if (noDecimalCurrencies.includes(currency)) {
    return `${Math.round(price).toLocaleString()} ${code}`;
  }
  
  return `${parseFloat(price).toFixed(2)} ${code}`;
};

// Legacy function with symbol (kept for backward compatibility)
export const formatPriceWithSymbol = (price, currency = 'USD') => {
  const symbol = CURRENCY_SYMBOLS[currency] || '$';
  
  const noDecimalCurrencies = ['JPY', 'KRW', 'VND'];
  
  if (noDecimalCurrencies.includes(currency)) {
    return `${symbol}${Math.round(price).toLocaleString()}`;
  }
  
  return `${symbol}${parseFloat(price).toFixed(2)}`;
};

// Renamed for clarity - same as formatPrice
export const formatPriceWithCode = (price, currency = 'USD') => {
  return formatPrice(price, currency);
};

export const getCurrencySymbol = (currency = 'USD') => {
  return CURRENCY_SYMBOLS[currency] || '$';
};

export const getCurrencyInfo = (currency = 'USD') => {
  return CURRENCY_INFO[currency] || CURRENCY_INFO['USD'];
};